import * as React from 'react'
import { createStyles, Theme, WithStyles, withStyles, Table, TableHead, TableRow, TableCell, TableBody, Chip, Icon } from '@material-ui/core'
import { compose } from 'redux'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import autobind from 'autobind-decorator'
import { connect } from 'react-redux'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import { RootState } from 'src/core/redux/reducer'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { RouteComponentProps, withRouter } from 'react-router'
import { withToast } from 'src/shared/Toast'
import { WithToast } from 'src/shared/Toast/Toast'
import { getMembers, toggleMember } from 'src/core/redux/action/enterpriseInfosAction'
import { boolToValue } from 'src/shared/utils/helpers'
import Btn from 'src/shared/Btn/Btn'
import { css } from 'src/conf/style'

const styles = (t: Theme) => createStyles({
    card: {
        height: '100%'
    },
    tabLbl: {
        ...css.flexAlCenter
    },
    badge2: {
        ...css.flexAlCenter,
        borderRadius: '4px',
        padding: '0 5px',
        color: t.palette.common.white,
        background: 'rgb(63,81,181)',
        marginLeft: '.75rem',
        textAlign: 'center',
        maxHeight: '24px',
        justifyContent: 'center',
        fontSize: '0.875rem'
    },
    expansionPnl: {
        boxShadow: 'none',
        '&:before': {
            display: 'none'
        },
    },
    title: {
        fontSize: '1.2rem',
        fontWeight: 'normal',
        lineHeight: '1.35417em',
        textTransform: 'uppercase'
    },

    xsScroll: {
        [t.breakpoints.down('sm')]: {
            overflow: 'auto'
        },
    },
    readOnlyAccess: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
    }
});


interface IProps extends WithStyles<typeof styles>,
    WithI18n,
    WithToast,
    WithGlobalProgress,
    RouteComponentProps<any>,
    ReturnType<typeof state2props>,
    ReturnType<typeof dispatch2props> {
}


class EnterprisePhysicalPerson extends React.Component<IProps, {}> {

    render() {
        const { t, members, connectedUser, classes } = this.props;
        return (
            <>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>{t.EnterpriseInfo_members_col_fullname}</TableCell>
                            <TableCell style={{ textAlign: 'center' }}>{t.EnterpriseInfo_members_col_representative}</TableCell>
                            <TableCell style={{ textAlign: 'center' }}>{t.EnterpriseInfo_members_col_change}</TableCell>
                            <TableCell style={{ textAlign: 'center' }}>{t.EnterpriseInfo_members_col_dette}</TableCell>
                            <TableCell style={{ textAlign: 'center' }}>{t.EnterpriseInfo_members_col_placement}</TableCell>
                            <TableCell style={{ textAlign: 'center' }}>{t.EnterpriseInfo_members_col_notified}</TableCell>
                            <TableCell>{t.actions}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {members &&
                            <>
                                {members.filter(m => m.id !== connectedUser.id).map(m => {
                                    return (
                                        <TableRow key={`members-${m.id}`}>
                                            <TableCell>
                                                <div className={classes.readOnlyAccess}>
                                                    {m.last_name + " " + m.first_name}
                                                    {m.read_only_access && <Icon color={"primary"}>preview</Icon>}
                                                </div>
                                            </TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>
                                                {m.is_mandataire === true ?
                                                    <Chip key={`mandataire-${m.id}`} label={t.yes} />
                                                    : t[boolToValue(m.is_mandataire)]
                                                }
                                            </TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>
                                                {m.habilitations.includes("change") === true ?
                                                    <Chip key={`change-${m.id}`} label={t.yes} />
                                                    : t[boolToValue(m.habilitations.includes("change"))]
                                                }
                                            </TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>
                                                {m.habilitations.includes("dette") === true ?
                                                    <Chip key={`dette-${m.id}`} label={t.yes} />
                                                    : t[boolToValue(m.habilitations.includes("dette"))]
                                                }
                                            </TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>
                                                {m.habilitations.includes("placement") === true ?
                                                    <Chip key={`placement-${m.id}`} label={t.yes} />
                                                    : t[boolToValue(m.habilitations.includes("placement"))]
                                                }
                                            </TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>
                                                {m.has_been_notified === true ?
                                                    <Chip key={`mandataire-${m.id}`} label={t.yes} />
                                                    : t[boolToValue(m.has_been_notified)]
                                                }
                                            </TableCell>
                                            <TableCell>
                                                <Btn
                                                    color="primary"
                                                    variant="raised"
                                                    onClick={() => this.toggleAccessMember(m.id)}
                                                >
                                                    {m.activated ? "INTERDIRE L’ACCES" : "Autoriser l'accès"}
                                                </Btn>
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            </>
                        }
                    </TableBody>
                </Table>
            </>
        )
    }


    componentDidMount() {
        const { promisesWithProgress, fetch, toastError } = this.props
        promisesWithProgress(
            fetch().catch(err => toastError(err.msg))
        )
    }

    @autobind
    private toggleAccessMember(id: string) {
        const { promisesWithProgress, fetch, toastError } = this.props
        promisesWithProgress(
            this.props.toggleMember(id).then(res => fetch().catch(err => toastError(err.msg))).catch(err => toastError(err.msg))
        )
    }
}

const state2props = (state: RootState) => ({
    connectedUser: state.accountInfo.connectedUser,
    members: state.paginate.enterpriseMembers.entities,
    isFetching: state.paginate.enterpriseMembers.isFetching,
    memberSize: state.paginate.enterpriseMembers.total_size
});

const dispatch2props = dispatch => ({
    fetch: () => dispatch(getMembers()),
    toggleMember: (userId: string) => dispatch(toggleMember(userId))
});


export default compose(
    withI18n,
    withGlobalProgress,
    withRouter,
    withToast,
    connect(state2props, dispatch2props),
    withStyles(styles)
)(EnterprisePhysicalPerson)



// WEBPACK FOOTER //
// ./src/page/Consumer/Enterprise/cards/EnterprisePhysicalPerson.tsx